module.exports = __webpack_public_path__ + "img/9788959122431.3bed6b1f.jpg";